import Actions                  from 'Redux/Actions';
import { EventRepository }      from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const updateEventEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateEventRequest.type),
    mergeMap(action => from(EventRepository.update(action.payload.id, action.payload.formData))
      .pipe(
        mergeMap((event) => {
          message.success('Die Speicherung des Events erfolgreich.');

          return from([
            Actions.updateEventSuccess({ event }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateEventFailure({ error })
          ]);
        })
      )
    ),
  );
};
